module.exports = __webpack_public_path__ + "static/img/valuess-02.e1e66f56.png";